// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__36GP_","title":"BackImages_title__2HFaZ","images":"BackImages_images__2GS9U"};